import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';

const { FiPlus, FiMinus } = FiIcons;

const faqs = [
  { q: 'Is this book only for women in relationships?', a: 'Not at all. While the primary audience is women who love or want to love a good man, many male readers have found it deeply illuminating for understanding themselves. Therapists and coaches also use it as a reference.' },
  { q: 'Is this book available internationally?', a: 'Yes. The Kindle edition is available worldwide through Amazon. The paperback and hardcover are also available for international shipping through Amazon, and the digital version is available directly through the author\'s website.' },
  { q: 'What makes this book different from other relationship books?', a: 'Most relationship books offer generic advice. This book goes deeper — it presents the male emotional world from the inside, with specific, actionable truths rather than vague platitudes. Readers consistently say it feels like finally getting a genuine answer.' },
  { q: 'How long is the book and how quickly can I read it?', a: 'The book is designed to be read in a weekend, though many readers prefer to take it one chapter (one truth) at a time to let each insight sink in. It\'s written to be accessible, not academic.' },
  { q: 'Can I gift this book to someone?', a: 'Absolutely. The hardcover edition makes a beautiful, meaningful gift. The Kindle version can also be gifted through Amazon\'s gifting feature.' },
];

const FaqStrip = () => {
  const [open, setOpen] = useState(null);

  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="text-brand-accent font-semibold tracking-widest uppercase text-xs">FAQ</span>
          <h3 className="text-4xl font-serif font-bold text-brand-dark mt-3">Common Questions</h3>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-white rounded-2xl border border-slate-100 overflow-hidden shadow-sm">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex justify-between items-center p-6 text-left"
              >
                <span className="font-medium text-brand-dark pr-4">{faq.q}</span>
                {open === i ? <FiMinus className="text-brand-accent flex-shrink-0" /> : <FiPlus className="text-slate-400 flex-shrink-0" />}
              </button>
              <AnimatePresence>
                {open === i && (
                  <motion.div
                    initial={{ height: 0 }}
                    animate={{ height: 'auto' }}
                    exit={{ height: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <p className="px-6 pb-6 text-slate-600 leading-relaxed">{faq.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqStrip;